import React from "react";
import { observer } from "mobx-react";
import Moment from 'react-moment';
import 'moment-timezone';

const DisplayTime = observer((props) => {
    
    let momentProps = {...props};
    momentProps.format = "ddd, MMM D, YYYY @ hh:mm A (z)";

      return (
        <>
            <Moment {...momentProps}>
                {props.date}
            </Moment>
        </>
      );

  });
  
  export default DisplayTime;
  